import React from 'react';

import { DatePickerProps } from './DatePicker.types';
import DatePickerBase from './DatePickerBase';

const DatePicker = (props: DatePickerProps) => {

  return (
    <DatePickerBase
      inline={true}
      {...props}
    />
  );
};

export default DatePicker;
